import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconCircleThreeQuarterSolid = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M12 2h-1v9H2v1a10 10 0 0 0 17.07 7.07A10 10 0 0 0 12 2z" }) }));
const Memo = memo(SvgIconCircleThreeQuarterSolid);
export default Memo;
//# sourceMappingURL=IconCircleThreeQuarterSolid.js.map